import React from 'react';
import PropTypes from 'prop-types';

import Date from "components/Display/ViewDate";
import Amount from "components/Display/Amount";
import Percentage from "components/Display/Percentage";
import YesNo from "components/Display/YesNo";

import Checkbox from "jsx/elements/inputs/Checkbox";
import TransactionKey from "../Display/TransactionKey";
import CostCalculatedFor from "../Display/CostCalculatedFor";
import RecordNumber from "../Display/RecordNumber";


class PrincipalResultBondTable extends React.Component {

  state = {
    showPayments : false,
    showAllCapitals : false
  };

  constructor(props){
    super(props);
    this.showshowPaymentsClick = this.showshowPaymentsClick.bind(this);
    this.showshowAllCapitalsClick = this.showshowAllCapitalsClick.bind(this);
  }

  showshowPaymentsClick(){
    this.setState({ showPayments: !this.state.showPayments });
  };

  showshowAllCapitalsClick(){
    this.setState({ showAllCapitals: !this.state.showAllCapitals });
  };





  render() {
    if (!this.props.data.legs){
      return (
        <div/>
      );
    }

    let principals = this.props.data.bond.legs[0].principals;

    let table1 = (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />            
          </colgroup>
          <thead>
          <tr>
            <th colSpan="10" className="text-left">
              <span className="calc-setting-table-header">Höfuðstólar sem voru notaðar í útreikningum ásamt nánari upplýsingum ef það er til staðar.&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <input id="checkPrinciaplsid1" type="checkbox" checked={this.state.showPayments} onChange={this.showshowPaymentsClick}/><label className="calc-small-checkbox-label" htmlFor="checkPrinciaplsid1" >Sýna greiðslur</label> &nbsp; &nbsp;
              <input id="checkPrinciaplsid2" type="checkbox" checked={this.state.showAllCapitals} onChange={this.showshowAllCapitalsClick}/><label className="calc-small-checkbox-label" htmlFor="checkPrinciaplsid2" >Sýna framtíðar höfuðstóla</label>
            </th>
          </tr>
          <tr>
            <th className="text-left">G.nr.</th>
            <th className="text-left">Gjalddagi</th>
            <th className="text-right">Höf. í upph.</th>
            <th className="text-right">Afborgun</th>
            <th className="text-right">Vextir</th>
            <th className="text-right">Vaxta %</th>
            <th className="text-right">Heildargr.</th>
            <th className="text-right">Kostn.</th>
            <th className="text-right">H.gr.m.k.</th>                        
          </tr>
          </thead>
          <tbody>
          {principals.map((item,i) => {
            if (!this.state.showAllCapitals && item.isFuturePayment) {
              return;
            }        

            let cName = "";
            if (item.paymentNumber % 2 === 1){
              cName =  'calc-setting-table-odd';
            }
            cName = cName + (item.isFuturePayment ? ' highlight-principal-future' : '');
            if ((item.paymentNumber === 35) || (item.paymentNumber === 68) || (item.paymentNumber === 150)){
              cName = ' highlight-principal-mine';
            }
            
        
            return([
                <tr key={i + "inner"} className={cName}>
                  <td className="text-left"><RecordNumber data={item.paymentNumber}/></td>                  
                  <td className="text-left"><Date data={item.dueDate}/></td>
                  <td className="text-right"><b><Amount data={item.capitalTotalAmount}/></b></td>
                  <td className="text-right"><b><Amount data={item.totalAmount}/></b></td>
                  <td className="text-right"><b><Amount data={item.interestTotalAmount}/></b></td>
                  <td className="text-right"><Amount data={item.interestAmount}/></td>
                  <td className="text-right"><Percentage data={item.interestRate}/></td>
                  <td className="text-right"><Amount data={item.totalPaymentAmount}/></td> 
                  <td className="text-right"><Amount data={item.costAmount}/></td>                 
                  <td className="text-right"><b><Amount data={item.totalPaymentAmount + item.costAmount}/></b></td>                                   
                </tr>]
            )
          })}
          </tbody>
        </table>
      </div>
    );

   
    
    return (
      <div>
        {table1}   
      </div>
    );
  }
}

PrincipalResultBondTable.propTypes = {
  data: PropTypes.object,
};



export default PrincipalResultBondTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Results/PrincipalResultBondTable.js